import { IIconProps } from "../types"

export default function IconUR7(props: IIconProps) {
  const width = props.size || props.width || 95
  const height = props.size || props.height || 74
  const fill = props.fill || "white"
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 95 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.9451 1.06265C40.0951 0.702651 46.2751 0.632651 52.2951 0.962651C58.3251 1.28265 64.1751 2.00265 68.3751 2.95265C72.5751 3.89265 75.1151 5.06265 77.5251 7.18265C79.9351 9.29265 82.2151 12.3527 84.6851 16.8127C87.1651 21.2727 89.8351 27.1327 91.4251 31.2027C93.0251 35.2727 93.5451 37.5527 93.7651 40.9726C93.9951 44.3827 93.9351 48.9426 93.2851 52.6227C92.6351 56.3027 91.3951 59.1026 89.9951 61.8027C88.5951 64.5027 87.0351 67.1126 85.2051 68.9326C83.3851 70.7526 81.3051 71.7926 78.9951 72.2826C76.6751 72.7727 74.1351 72.7126 70.9451 72.2826C67.7551 71.8626 63.9151 71.0826 58.8751 70.2626C53.8251 69.4527 47.5751 68.6027 42.9551 68.6426C38.3351 68.6727 35.3351 69.5826 32.8351 70.3626C30.3251 71.1426 28.3051 71.7926 25.8351 71.7327C23.3551 71.6627 20.4251 70.8827 17.5651 69.5126C14.6951 68.1526 11.8951 66.1926 9.23506 63.0727C6.56506 59.9426 4.02506 55.6526 2.45506 51.4827C0.895062 47.3126 0.315062 43.2826 1.09506 38.5927C1.87506 33.9026 4.02506 28.5627 6.36506 23.3927C8.71506 18.2127 11.2451 13.2027 13.8251 9.78265C16.3951 6.36265 18.9951 4.54265 22.3451 3.30265C25.7051 2.07265 29.8051 1.42265 34.9451 1.06265Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.9451 1.06265C40.0951 0.702651 46.2751 0.632651 52.2951 0.962651C58.3251 1.28265 64.1751 2.00265 68.3751 2.95265C72.5751 3.89265 75.1151 5.06265 77.5251 7.18265C79.9351 9.29265 82.2151 12.3527 84.6851 16.8127C87.1651 21.2727 89.8351 27.1327 91.4251 31.2027C93.0251 35.2727 93.5451 37.5527 93.7651 40.9726C93.9951 44.3827 93.9351 48.9426 93.2851 52.6227C92.6351 56.3027 91.3951 59.1026 89.9951 61.8027C88.5951 64.5027 87.0351 67.1126 85.2051 68.9326C83.3851 70.7526 81.3051 71.7926 78.9951 72.2826C76.6751 72.7727 74.1351 72.7126 70.9451 72.2826C67.7551 71.8626 63.9151 71.0826 58.8751 70.2626C53.8251 69.4527 47.5751 68.6027 42.9551 68.6426C38.3351 68.6727 35.3351 69.5826 32.8351 70.3626C30.3251 71.1426 28.3051 71.7926 25.8351 71.7327C23.3551 71.6627 20.4251 70.8827 17.5651 69.5126C14.6951 68.1526 11.8951 66.1926 9.23506 63.0727C6.56506 59.9426 4.02506 55.6526 2.45506 51.4827C0.895062 47.3126 0.315062 43.2826 1.09506 38.5927C1.87506 33.9026 4.02506 28.5627 6.36506 23.3927C8.71506 18.2127 11.2451 13.2027 13.8251 9.78265C16.3951 6.36265 18.9951 4.54265 22.3451 3.30265C25.7051 2.07265 29.8051 1.42265 34.9451 1.06265Z"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 1.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.9451 1.06265C40.0951 0.702651 46.2751 0.632651 52.2951 0.962651C58.3251 1.28265 64.1751 2.00265 68.3751 2.95265C72.5751 3.89265 75.1151 5.06265 77.5251 7.18265C79.9351 9.29265 82.2151 12.3527 84.6851 16.8127C87.1651 21.2727 89.8351 27.1327 91.4251 31.2027C93.0251 35.2727 93.5451 37.5527 93.7651 40.9726C93.9951 44.3827 93.9351 48.9426 93.2851 52.6227C92.6351 56.3027 91.3951 59.1026 89.9951 61.8027C88.5951 64.5027 87.0351 67.1126 85.2051 68.9326C83.3851 70.7526 81.3051 71.7926 78.9951 72.2826C76.6751 72.7727 74.1351 72.7126 70.9451 72.2826C67.7551 71.8626 63.9151 71.0826 58.8751 70.2626C53.8251 69.4527 47.5751 68.6027 42.9551 68.6426C38.3351 68.6727 35.3351 69.5826 32.8351 70.3626C30.3251 71.1426 28.3051 71.7926 25.8351 71.7327C23.3551 71.6627 20.4251 70.8827 17.5651 69.5126C14.6951 68.1526 11.8951 66.1926 9.23506 63.0727C6.56506 59.9426 4.02506 55.6526 2.45506 51.4827C0.895062 47.3126 0.315062 43.2826 1.09506 38.5927C1.87506 33.9026 4.02506 28.5627 6.36506 23.3927C8.71506 18.2127 11.2451 13.2027 13.8251 9.78265C16.3951 6.36265 18.9951 4.54265 22.3451 3.30265C25.7051 2.07265 29.8051 1.42265 34.9451 1.06265Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 1.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.0039 27.1328C41.9739 30.6528 45.9439 34.1628 47.3539 41.1028C48.7539 48.0428 47.5939 58.3928 46.4239 68.7528"
        fill={fill}
      />
      <path
        d="M38.0039 27.1328C41.9739 30.6528 45.9439 34.1628 47.3539 41.1028C48.7539 48.0428 47.5939 58.3928 46.4239 68.7528"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 1.8"
      />
      <path
        d="M38.0039 27.1328C41.9739 30.6528 45.9439 34.1628 47.3539 41.1028C48.7539 48.0428 47.5939 58.3928 46.4239 68.7528"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 1.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.497 27.5234C64.047 29.4134 60.597 31.3034 57.237 32.8334C53.877 34.3534 50.597 35.5234 48.967 36.8434C47.337 38.1634 47.347 39.6334 47.357 41.1034"
        fill={fill}
      />
      <path
        d="M67.497 27.5234C64.047 29.4134 60.597 31.3034 57.237 32.8334C53.877 34.3534 50.597 35.5234 48.967 36.8434C47.337 38.1634 47.347 39.6334 47.357 41.1034"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 1.8"
      />
      <path
        d="M67.497 27.5234C64.047 29.4134 60.597 31.3034 57.237 32.8334C53.877 34.3534 50.597 35.5234 48.967 36.8434C47.337 38.1634 47.347 39.6334 47.357 41.1034"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 1.8"
      />
    </svg>
  )
}
